const $=(s,c=document)=>c.querySelector(s);
const root=window.KF_ROOT||'/';
function openCart(){document.body.classList.add('drawer-open')}
function closeCart(){document.body.classList.remove('drawer-open')}
document.addEventListener('click',e=>{
 if(e.target.closest('[data-cart-open]'))openCart();
 if(e.target.closest('[data-cart-close]'))closeCart();
 if(e.target.closest('[data-mobile-toggle]'))$('#PrimaryNav')?.classList.toggle('open');
 if(e.target.matches('[data-age-confirm]')){localStorage.setItem('kf_age_verified','1');$('#AgeGate')?.classList.remove('active')}
 if(e.target.matches('[data-age-leave]'))history.back();
});
async function refreshDrawer(){
 const r=await fetch(`${root}?sections=cart-drawer`);
 const j=await r.json();
 const doc=new DOMParser().parseFromString(j['cart-drawer'],'text/html');
 const fresh=doc.querySelector('#CartDrawer');
 if(fresh)$('#CartDrawer')?.replaceWith(fresh);
}
document.addEventListener('submit',async e=>{
 const form=e.target.closest('[data-product-form]');
 if(!form)return;
 e.preventDefault();
 const b=form.querySelector('[type=submit]'); b.disabled=true;
 try{
  const r=await fetch(`${root}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
  if(!r.ok)throw new Error('Produkt konnte nicht hinzugefügt werden.');
  await refreshDrawer(); openCart();
 }catch(err){alert(err.message)}finally{b.disabled=false}
});
const gate=$('#AgeGate');
if(gate&&!localStorage.getItem('kf_age_verified'))gate.classList.add('active');